import type { Middleware } from 'openapi-fetch';

/** Throw response body as error.
 * Used for enabling openapi-react-query error handling.
 * This middleware will throw the response body as an error if the response status is not ok (i.e. not in the range 200-299).
 * This allows us to handle errors that are not part of the spec with react query.
 * Without middleware, openapi-react-query will only register errors that are defined in the spec.
 */
export const throwBodyOnNonOkResponse: Middleware = {
  async onResponse({ response }) {
    if (!response.ok) {
      throw await response.clone().json();
    }

    return response;
  },
};
